/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */function o(t){const c=[];for(let e=0;e<t.length;e++){const n=t[e];n.selected&&c.push([n,e])}return c}export{o as getSelectedItems};
